import * as React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "../../shared/contexts/AuthContext";
import {
  PATH_DONORS,
  PATH_ADD_DONOR,
  PATH_DASHBOARD,
  PATH_DONOR_VIEW,
  PATH_DONOR_EDIT,
  PATH_USERS,
  PATH_USER_ADD,
  PATH_USER_EDIT,
  PATH_PROFILE
} from "./RouteConstants";
import Spinner from "../../shared/components/spinner/Spinner";

const Dashboard = React.lazy(() => import("../dashboard/Dashboard"));
const Donors = React.lazy(() => import("../donors/Donors"));
const Donor = React.lazy(() => import("../donors/donor/Donor"));
const AddOrUpdateDonor = React.lazy(() => import("../donors/add-donor/AddOrUpdateDonor"));
const Users = React.lazy(() => import("../users/Users"));
const AddOrUpdateUser = React.lazy(() => import("../users/add-user/AddOrUpdateUser"));
const UserProfile = React.lazy(() => import("../profile/UserProfile"));

const AppRoutes: React.FunctionComponent = () => {
  const { userRole } = useAuth();
  const isAdmin = userRole === "admin" || userRole === "super_admin";

  return (
    <React.Suspense fallback={<Spinner height="91.8vh" />}>
      <Routes>
        <Route path={PATH_DASHBOARD} element={<Dashboard />} />
        <Route path={PATH_DONORS} element={<Donors />} />
        <Route path={PATH_DONOR_VIEW} element={<Donor />} />
        <Route path={PATH_ADD_DONOR} element={<AddOrUpdateDonor />} />
        <Route path={PATH_DONOR_EDIT} element={<AddOrUpdateDonor />} />
        <Route path={PATH_PROFILE} element={<UserProfile />} />
        <Route path={PATH_USER_ADD} element={<AddOrUpdateUser />} />
        <Route path={PATH_USER_EDIT} element={<AddOrUpdateUser />} />

        {/* Admin only routes */}
        {isAdmin && <Route path={PATH_USERS} element={<Users />} />}

        <Route path="/*" element={<Navigate to={PATH_DASHBOARD} />} />
      </Routes>
    </React.Suspense>
  );
};

export default AppRoutes;
